import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { t, hours, money, percent, shortDate, performanceTone, varianceTone } from "../format"
import { Sparkline } from "./Charts"

const Tile = ({ icon, label, value, tone = "text-slate-900", children }) => (
  <div className="bg-white border border-slate-200 rounded-xl px-4 py-3.5 min-w-0">
    <div className="flex items-center justify-between gap-2">
      <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-500 truncate">{label}</div>
      <FontAwesomeIcon icon={icon} className="w-3 h-3 text-slate-400 shrink-0" />
    </div>
    <div className={`mt-2 text-[24px] leading-none font-bold tabular-nums ${tone}`}>{value}</div>
    <div className="mt-1.5 text-[11.5px] text-slate-500 min-h-[16px]">{children}</div>
  </div>
)

const Tiles = ({ totals = {}, currency }) => {
  const variance = totals.projected_variance || 0
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
      <Tile icon="file-signature" label={t("tiles.sold")} value={hours(totals.sold)}>
        {t("tiles.sold_hint", { count: totals.count || 0 })}
      </Tile>
      <Tile icon="calendar-days" label={t("tiles.planned")} value={hours(totals.planned)} tone="text-sky-700">
        {totals.planned_ahead > 0 ? t("tiles.planned_ahead", { hours: hours(totals.planned_ahead) }) : t("tiles.nothing_ahead")}
      </Tile>
      <Tile icon="person-digging" label={t("tiles.done")} value={hours(totals.done)}>
        <span className="flex items-center justify-between gap-2">
          <span>{t("tiles.consumed", { pct: percent(totals.consumed) })}</span>
          <Sparkline values={totals.trend || []} className="h-4" />
        </span>
      </Tile>
      <Tile icon="gauge-high" label={t("tiles.performance")} value={totals.performance ? percent(totals.performance * 100) : "–"}
            tone={performanceTone(totals.performance)}>
        {totals.performance ? t("tiles.earned", { hours: hours(totals.earned) }) : t("tiles.no_progress")}
      </Tile>
      <Tile icon="flag-checkered" label={t("tiles.projected")} value={hours(variance, { signed: true })} tone={varianceTone(variance, totals.sold)}>
        {t("tiles.projected_hint", { hours: hours(totals.projected), money: money(totals.projected_variance_cents, currency, { signed: true }) })}
      </Tile>
      <Tile icon="stamp" label={t("tiles.pending")} value={hours(totals.pending)} tone={totals.pending > 0 ? "text-amber-700" : "text-slate-900"}>
        {totals.oldest_pending ? t("tiles.oldest", { date: shortDate(totals.oldest_pending) }) : t("tiles.all_approved")}
        {totals.unplanned > 0 && <> · {t("tiles.unplanned", { hours: hours(totals.unplanned) })}</>}
      </Tile>
    </div>
  )
}

export default Tiles
